/* global document */
import '../../../styles/next/blocks/_promo.scss';
import initBackgroundVideos from '../next-hero-video';

// acf/next-promo: the background and tile videos play on the front end.
const init = () => {
  initBackgroundVideos('.aqn-promo-video');
  initBackgroundVideos('.aqn-promo-lockup-video');
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
